





















































































































import { Component, Vue } from 'vue-property-decorator';
import ITopic from '@/lib/ITopic';
import Lockr from 'lockr';
import Product from '@/lib/IProduct';
import ProductClass from '@/lib/IProductClass';
import ProductCarousel from '@/components/ProductCarousel.vue';
import VideoFile from '@/lib/VideoFile';
import VideoPlayer from '@/components/VideoPlayer.vue';
import { analytics } from '@/lib/util/FirebaseConfig';
import { db } from '@/lib/ProductDatabase';
import { kioskSetup } from '@/lib/KioskSetup';
import { $nav } from '@/lib/KioskNavigation';

@Component({
  components: {
    ProductCarousel,
    VideoPlayer,
  },
})
export default class MainDisplay extends Vue {

  // reactive properties

  // non-reactive properties

  // lifecycle

  // computed
  get frontPageProducts(): ProductClass[] {
    return db.getAllProductClasses();
  }
  get topics(): ITopic[] {
    return db.getAllTopics();
  }
  get whitelabelPath(): string {
    return db.getWhitelabelPath();
  }
  get frontPageVideoFiles(): VideoFile[] {
    return db.getFrontPageVideoFiles();
  }

  // methods
  formattedPrice(priceInCents: number): string {
    const dollars = Math.floor(priceInCents / 100);
    const cents = priceInCents - (dollars * 100);
    return '$' + dollars + '.' + ((cents < 10) ? '0' : '') + cents;
  }

  getTopicName(topicId: string): string {
    const topic = this.topics.find((t) => t.id === topicId);
    if ( topic ) {
      return topic.name;
    }
    return 'unknown topic';
  }

  btnSeeTopic(topicId: string) {
    const topicName = this.getTopicName(topicId);
    console.log(`btnSeeTopic ${topicName}`);
    analytics.logEvent("button", { kioskId: kioskSetup.kioskId, name: topicName});
    analytics.logEvent("view_item_list", { kioskId: kioskSetup.kioskId, items: [{category: topicName}] });
    $nav.to(this, '/topic/' + topicId);
  }

  btnSeeProducts() {
    console.log(`btnSeeProducts`);
    analytics.logEvent("button", { kioskId: kioskSetup.kioskId, name: "Browse Products"});
    analytics.logEvent("view_item_list", { kioskId: kioskSetup.kioskId, items: [{category: 'all_products'}] });
    $nav.to(this, '/products');
  }

}

